import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const IRHistoryApi = createApi({
  reducerPath: "IRHistory",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}`,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getIRHistory: builder.query({
      query: (params) => {
        const {
          type,
          project,
          discipline,
          requestStatus,
          startDate,
          endDate,
          page = 1,
          pageSize = 10,
          sortBy,
          sortOrder,
          search,
          historyType,
          role,
        } = params || {};

        const queryParams = new URLSearchParams();
        if (type) queryParams.append("type", type);
        if (project) queryParams.append("project", project);
        if (discipline) queryParams.append("disciplines", discipline);
        if (requestStatus) queryParams.append("requestStatus", requestStatus);
        if (startDate) queryParams.append("startDate", startDate);
        if (endDate) queryParams.append("endDate", endDate);
        if (page) queryParams.append("page", page);
        if (pageSize) queryParams.append("limit", pageSize);
        if (sortBy) queryParams.append("sortBy", sortBy);
        if (sortOrder) queryParams.append("sortOrder", sortOrder);
        if (search) queryParams.append("search", search);

        return `/${historyType}/${role}/history?${queryParams.toString()}`;
      },
    }),
  }),
});

export const { useGetIRHistoryQuery, useLazyGetIRHistoryQuery } = IRHistoryApi;
